module.exports = __webpack_public_path__ + "img/rxk_img3.ee1a4f96.png";